// -----------------------------------------------------------------------------
// Firebase Web (browser push) configuration seam.
//
// This file is a GATED SEAM: with the placeholders below it ships INERT — the
// web-push client (utils/webPush.ts) detects `isWebPushConfigured === false`,
// registers NO service worker, loads NO Firebase SDK, and falls back to a bare
// browser permission prompt. Paste the real values and it activates with NO
// code change.
//
// -----------------------------------------------------------------------------
// TO ACTIVATE (exactly two Firebase-console actions) — see WEB_PUSH_SETUP.md:
//
//   1. Register a Web app in the Firebase console for project `mowazaf-2a5f6`
//      (Project settings → General → "Your apps" → Add app → Web </>). Copy the
//      generated `firebaseConfig` and paste `apiKey`, `storageBucket`, and
//      `appId` into `firebaseWebConfig` below. (authDomain / projectId /
//      messagingSenderId are already filled from the existing project.)
//
//   2. Generate a Web Push certificate: Project settings → Cloud Messaging →
//      "Web configuration" → Web Push certificates → Generate key pair. Copy the
//      public key ("Key pair" value) into `VAPID_KEY` below.
//
// IMPORTANT: the SAME apiKey / authDomain / projectId / storageBucket /
// messagingSenderId / appId values must ALSO be pasted into the service worker
// at `public/firebase-messaging-sw.js` (a service worker cannot import this TS
// module, so its config is duplicated there on purpose).
// -----------------------------------------------------------------------------

// Obvious placeholder sentinel. `isWebPushConfigured` stays false while any
// required field still starts with this prefix.
const PLACEHOLDER_PREFIX = 'REPLACE_WITH_';

export const firebaseWebConfig = {
  apiKey: 'AIzaSyB_vSYOZ8aj3U_GRpj4gdrfzuf4t8rDtyI',
  authDomain: 'mowazaf-2a5f6.firebaseapp.com',
  projectId: 'mowazaf-2a5f6',
  storageBucket: 'mowazaf-2a5f6.firebasestorage.app',
  messagingSenderId: '136859873707',
  appId: '1:136859873707:web:0a91ab0effb36e2cd062ee',
};

// Web Push certificate public key (VAPID). Paste from Firebase console →
// Cloud Messaging → Web Push certificates → Generate key pair.
export const VAPID_KEY =
  'BEiV47te1vDrFve8iFC2dFLsaR9IxZotJixO0KWOC6A8SLI7XVQS08athfohd1VcN6A5ztmug2Iy77PbIhIm6sQ';

function isFilled(value: string): boolean {
  return (
    typeof value === 'string' &&
    value.length > 0 &&
    !value.startsWith(PLACEHOLDER_PREFIX)
  );
}

// TRUE only once the three values that web push cannot function without —
// apiKey, appId, and the VAPID public key — have all been replaced. Until then
// the client stays on its graceful fallback path.
export const isWebPushConfigured: boolean =
  isFilled(firebaseWebConfig.apiKey) &&
  isFilled(firebaseWebConfig.appId) &&
  isFilled(VAPID_KEY);
